export type ClientContactRecord = {
  id?: number;
  is_master?: boolean;
  is_active?: boolean;
};

/** Contact is not soft-deleted. */
export const isActiveContact = (contact: ClientContactRecord) =>
  contact.is_active !== false;

/** All active contacts, oldest first. */
export const getActiveContacts = <T extends ClientContactRecord>(contacts: T[]): T[] =>
  [...contacts]
    .filter(isActiveContact)
    .sort((a, b) => (a.id ?? 0) - (b.id ?? 0));

/** Primary contact for list display: first active master by id, else first active contact. */
export const getPrimaryContact = <T extends ClientContactRecord>(contacts: T[]): T | null => {
  const active = getActiveContacts(contacts);
  if (!active.length) return null;

  const master = active.find((c) => c.is_master === true);
  return master ?? active[0];
};
